<template>
  <!-- BEGIN: Profile Info -->

  <div
    class="content-container overflow-auto scrollbar_custom bg-white rounded-md px-6"
  >
    <div
      class="flex flex-col lg:flex-row py-2 px-6 rounded-xl h-auto md:items-center justify-center"
    >
      <div class="flex-1 flex flex-col sm:flex-row items-center gap-1 lg:ml-10">
        <div class="mt-5">
          <svg id="icon-user_icon" viewBox="0 0 32 32" class="w-40">
            <path
              :fill="userData.color || '#ff8f1c'"
              d="M32 16.004c0 2.773-0.719 5.499-2.078 7.896-1.258 2.218-3.046 4.116-5.186 5.514-0.102 0.063-0.195 0.133-0.297 0.195-0.351 0.219-0.719 0.43-1.086 0.617-0.109 0.055-0.219 0.109-0.328 0.164-2.171 1.062-4.593 1.625-7.022 1.625s-4.757-0.531-6.92-1.57c-0.109-0.055-0.219-0.109-0.328-0.164-0.359-0.18-0.719-0.383-1.062-0.594-0.102-0.063-0.203-0.125-0.305-0.195-2.171-1.39-3.991-3.296-5.272-5.53-1.382-2.413-2.117-5.163-2.117-7.959 0-4.272 1.664-8.295 4.686-11.318s7.045-4.686 11.318-4.686 8.295 1.664 11.318 4.686c3.023 3.023 4.686 7.037 4.686 11.318z"
            ></path>
            <path
              :fill="isLight ? '#3A3A3A' : '#FFFFFF'"
              d="M9.068 14.668c0.187 0.141 0.422 0.203 0.648 0.164 0.492-0.078 0.812-0.531 0.742-1.054-0.195-1.39-0.148-2.617 0.141-3.757 0.445-1.765 1.453-2.913 2.991-3.421 1.289-0.43 2.624-0.476 3.952-0.148 1.632 0.406 2.429 1.304 2.437 2.749 0 0.406 0.258 0.711 0.687 0.82 0.625 0.156 1.008 0.562 1.195 1.281 0.211 0.789 0.086 1.593-0.078 2.421-0.109 0.555 0.18 1.008 0.695 1.109 0.055 0.008 0.109 0.016 0.164 0.016 0.422 0 0.773-0.312 0.875-0.789 0.156-0.742 0.297-1.617 0.18-2.546-0.18-1.406-0.797-2.359-1.882-2.921-0.117-0.063-0.141-0.086-0.156-0.219-0.18-1.258-0.851-2.242-1.976-2.929-1.093-0.656-2.312-0.945-4.077-0.953h-0.016s-0.016 0-0.016 0c-0.070 0-0.164 0.016-0.273 0.023-0.305 0.023-0.719 0.055-1.133 0.133-2.242 0.391-3.843 1.578-4.749 3.515-0.797 1.695-1.015 3.569-0.687 5.905 0.031 0.234 0.156 0.445 0.351 0.594z"
            ></path>
            <path
              :fill="isLight ? '#3A3A3A' : '#FFFFFF'"
              d="M24.752 24.556c-0.023-0.18-0.055-0.359-0.102-0.531-0.117-0.5-0.312-0.937-0.57-1.304-0.687-0.961-1.773-1.398-3.015-1.835-0.375-0.133-0.75-0.266-1.125-0.398-0.023-0.008-0.047-0.016-0.063-0.023-0.094-0.039-0.227-0.086-0.359-0.117-0.016 0-0.023 0-0.031-0.008 0-0.008 0-0.031 0-0.055 0-0.156 0-0.305 0-0.453 0-0.195 0-0.375 0.008-0.555 0-0.070 0.055-0.164 0.086-0.195 0.906-0.758 1.5-1.687 1.765-2.749 0.25-1 0.211-2.007 0.18-2.984-0.008-0.32-0.023-0.648-0.023-0.961 0-0.476-0.461-0.804-0.89-0.82-0.266 0-0.539 0-0.758 0.016-0.992 0.055-1.875-0.031-2.718-0.242-1.156-0.297-1.96-0.75-2.546-1.422-0.367-0.422-0.719-0.492-0.945-0.476-0.219 0.016-0.547 0.133-0.828 0.578-0.43 0.672-0.922 1.187-1.523 1.578-0.344 0.226-0.515 0.555-0.515 0.976 0 0.258 0 0.523 0 0.781 0 0.484 0 0.984 0 1.476 0.031 1.382 0.492 2.593 1.375 3.616 0.086 0.102 0.18 0.195 0.273 0.281 0.164 0.164 0.32 0.312 0.383 0.469 0.055 0.148 0.039 0.359 0.023 0.586-0.008 0.148-0.023 0.297-0.016 0.453 0 0.063 0 0.086 0 0.102-0.008 0-0.031 0.023-0.094 0.039-0.734 0.219-1.515 0.469-2.538 0.812-1.351 0.453-2.242 1.351-2.64 2.671-0.102 0.336-0.156 0.695-0.164 1.031-0.016 0.922-0.008 1.859-0.008 2.765 0 0.359 0 0.711 0 1.070s0 0.555 0.016 0.773c0.102 0.063 0.203 0.133 0.305 0.195 0.344 0.211 0.703 0.406 1.062 0.594 0.109 0.055 0.219 0.109 0.328 0.164v-0.187c0-0.555 0-1.304-0.008-1.625 0-0.078 0-0.133 0-0.141 0-0.297 0-0.601 0-0.898 0-0.789 0-1.601 0-2.406 0-0.289 0.023-0.5 0.063-0.687 0.219-0.929 0.828-1.515 1.867-1.796 0 0.078 0 0.148 0 0.227 0 0.437 0 0.883 0 1.328-0.742 0.32-1.25 1.070-1.25 1.89s0.922 2.062 2.062 2.062 2.062-0.922 2.062-2.062-0.453-1.507-1.148-1.851c0-0.453 0-0.914 0-1.39 0.195 0.195 0.398 0.391 0.594 0.594 0.633 0.625 1.258 1.25 1.89 1.875 0.484 0.476 1.101 0.523 1.578 0.109 1.367-1.179 2.492-2.164 3.538-3.093 0.023 0 0.055 0.016 0.086 0.023 0.437 0.125 1.64 0.68 1.929 0.929 0.086 0.078 0.172 0.164 0.242 0.25 0.242 0.305 0.406 0.703 0.476 1.195 0.070 0.461 0.047 0.945 0.031 1.414-0.016 0.375-0.023 1.226-0.039 2.124-0.008 0.68-0.023 1.382-0.031 1.851v0.195c0.109-0.055 0.219-0.109 0.328-0.164 0.367-0.187 0.726-0.398 1.086-0.617 0.102-0.063 0.203-0.125 0.297-0.195 0-0.297 0.008-0.625 0.016-0.953 0.008-0.82 0.023-1.664 0.039-2.031 0.023-0.609 0.039-1.234-0.039-1.867zM11.825 26.54c-0.219 0-0.398-0.18-0.398-0.398s0.18-0.398 0.398-0.398 0.398 0.18 0.398 0.398-0.18 0.398-0.398 0.398zM18.042 22.151c-0.656 0.57-1.297 1.133-1.937 1.695l-0.562-0.57c-0.531-0.539-1.054-1.078-1.586-1.617 0.547-0.414 0.601-1.047 0.594-1.625 1.086 0.328 2.164 0.328 3.234 0 0.016 0.281 0.023 0.578 0.086 0.867 0.078 0.359 0.281 0.633 0.633 0.844l-0.461 0.406zM16.012 18.581c-1.437-0.016-2.812-1.062-3.273-2.484-0.148-0.469-0.195-1-0.234-1.5-0.031-0.453-0.023-0.914-0.008-1.367 0-0.117 0-0.242 0-0.359 0-0.016 0.008-0.047 0.016-0.055 0.109-0.102 0.226-0.203 0.344-0.305 0.148-0.125 0.297-0.25 0.437-0.391 0.18-0.172 0.336-0.367 0.492-0.547 0 0 0 0 0.008-0.008 1.882 1.507 4.069 1.75 6.022 1.734 0 0.234 0 0.469 0 0.695 0.016 0.789 0.031 1.531-0.242 2.249-0.555 1.468-1.921 2.367-3.585 2.343z"
            ></path>
          </svg>
        </div>
        <div class="flex flex-col p-5 mt-5 gap-3">
          <div class="nunito text-2xl text-theme-40">
            {{ userData.first_name }}
            {{ userData.last_name }}
          </div>
          <div class="text-gray-600">
            {{ userData.role ? userData.role.name : '' }}
          </div>
          <div class="">
            <MailIcon class="w-4 h-4 mr-2" />
            {{ userData.email }}
          </div>
        </div>
      </div>
      <div class="w-full mt-5 px-6 lg:mt-0 lg:w-2/5 relative">
        <button
          class="my-3 flex gap-2 items-center w-full mx-auto"
          :class="[changePword ? 'gray-btn' : 'gray-btn-inverted']"
          @click="handleChangePword"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="h-4 fill-current"
          >
            <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M282.3 343.7L248.1 376.1C244.5 381.5 238.4 384 232 384H192V424C192 437.3 181.3 448 168 448H128V488C128 501.3 117.3 512 104 512H24C10.75 512 0 501.3 0 488V408C0 401.6 2.529 395.5 7.029 391L168.3 229.7C162.9 212.8 160 194.7 160 176C160 78.8 238.8 0 336 0C433.2 0 512 78.8 512 176C512 273.2 433.2 352 336 352C317.3 352 299.2 349.1 282.3 343.7zM376 176C398.1 176 416 158.1 416 136C416 113.9 398.1 96 376 96C353.9 96 336 113.9 336 136C336 158.1 353.9 176 376 176z"
            />
          </svg>
          Cambia Password
        </button>

        <button
          class="my-3 flex gap-2 items-center w-full mx-auto"
          :class="[openPicker ? 'gray-btn' : 'gray-btn-inverted']"
          @click="togglePicker"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="h-4 fill-current"
          >
            <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M482.8 29.23C521.7 68.21 521.7 131.4 482.8 170.4L381.2 271.9L390.6 281.4C403.1 293.9 403.1 314.1 390.6 326.6C378.1 339.1 357.9 339.1 345.4 326.6L185.4 166.6C172.9 154.1 172.9 133.9 185.4 121.4C197.9 108.9 218.1 108.9 230.6 121.4L240.1 130.8L341.6 29.23C380.6-9.744 443.8-9.744 482.8 29.23L482.8 29.23zM55.43 323.3L176.1 202.6L221.4 247.9L100.7 368.6C97.69 371.6 96 375.6 96 379.9V416H132.1C136.4 416 140.4 414.3 143.4 411.3L264.1 290.6L309.4 335.9L188.7 456.6C173.7 471.6 153.3 480 132.1 480H89.69L49.75 506.6C37.06 515.1 20.16 513.4 9.373 502.6C-1.413 491.8-3.086 474.9 5.375 462.2L32 422.3V379.9C32 358.7 40.43 338.3 55.43 323.3L55.43 323.3z"
            />
          </svg>

          Scegli colore
        </button>
        <div
          v-if="openPicker"
          class="absolute top-24 left-4 mx-auto p-5 rounded-lg"
          style="transform: translate(-50%); left: 50%"
        >
          <color-picker
            v-model:pureColor="pureColor"
            isWidget="true"
            format="hex"
            disableHistory="true"
            roundHistory="true"
            disableAlpha="true"
          />
          <div class="flex justify-end py-2">
            <button class="orange-btn" @click="saveColor">
              <SaveIcon class="h-5 w-5 mr-2 fill-curent" /> Salva
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="changePword"
      class="py-2 rounded-xl h-auto px-6 items-center justify-center mt-5 border border-theme-44 shadow-md border-opacity-20"
      autocomplete="off"
    >
      <h3 class="text-xl nunito text-theme-40 font-bold text-center mt-1 mb-5">
        Cambia la Password
      </h3>
      <div class="flex items-end justify-between gap-2">
        <div class="flex-1 flex flex-col lg:flex-row lg:items-center gap-2">
          <div class="flex-1 flex flex-col gap-1">
            <label for="old-Pword" class="form-label required">
              Vecchia Password</label
            >
            <input
              id="old-Pword"
              v-model="old_pword"
              autocomplete="off"
              type="text"
              :style="[!showPword ? '-webkit-text-security: disc' : '']"
              class="custom-input"
            />
          </div>
          <div class="flex-1 flex flex-col gap-1" autocomplete="off">
            <label for="new-Pword" class="form-label required">
              Nuova Password</label
            >

            <input
              id="new-Pword"
              v-model="new_pword"
              autocomplete="off"
              type="text"
              :style="[!showPword ? '-webkit-text-security: disc' : '']"
              class="custom-input"
            />
          </div>
          <div class="flex-1 flex flex-col gap-1" autocomplete="off">
            <label for="new-Pword" class="form-label required">
              Conferma Password
            </label>

            <input
              id="confirm-Pword"
              v-model="confirm_pword"
              autocomplete="off"
              type="text"
              :style="[!showPword ? '-webkit-text-security: disc' : '']"
              class="custom-input"
            />
          </div>
        </div>
        <button class="w-5 mb-3 flex">
          <div v-if="showPword" @click="showPword = false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              class="h-3 fill-current hover:text-theme-41"
            >
              <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z"
              />
            </svg>
          </div>
          <div v-else @click="showPword = true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
              class="h-3 fill-current hover:text-theme-41"
            >
              <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM223.1 149.5L313.4 220.3C317.6 211.8 320 202.2 320 191.1C320 180.5 316.1 169.7 311.6 160.4C314.4 160.1 317.2 159.1 320 159.1C373 159.1 416 202.1 416 255.1C416 269.7 413.1 282.7 407.1 294.5L446.6 324.7C457.7 304.3 464 280.9 464 255.1C464 176.5 399.5 111.1 320 111.1C282.7 111.1 248.6 126.2 223.1 149.5zM320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L177.4 235.8C176.5 242.4 176 249.1 176 255.1C176 335.5 240.5 400 320 400C338.7 400 356.6 396.4 373 389.9L446.2 447.5C409.9 467.1 367.8 480 320 480H320z"
              />
            </svg>
          </div>
        </button>
      </div>
      <div class="py-2" :class="[notValidated ? 'text-theme-41 ' : '']">
        <h2 class="text-xs font-semibold">
          La password deve essere composta da:
        </h2>
        <div class="flex flex-wrap items-center mt-1">
          <p class="text-xs mr-1">• Almeno 8 caratteri</p>
          <p class="text-xs mr-1">• Almeno una lettere maiuscola</p>
          <p class="text-xs mr-1">• Almeno una lettere minuscola</p>
          <p class="text-xs mr-1">• Almeno un numero</p>
          <p class="text-xs mr-1">• Almeno un carattere speciale (!@#$%^&*)</p>
        </div>
      </div>
      <div class="mt-5 flex items-center justify-end gap-2">
        <button type="button" class="orange-btn" @click="salvaPword">
          <SaveIcon class="h-5 w-5 mr-2" /> Salva
        </button>
        <button type="button" class="gray-btn" @click="changePword = false">
          <span class="h-5"></span>
          Annulla
        </button>
      </div>
    </div>
    <div class="flex flex-col my-10">
      <div class="flex modal-title justify-center">
        <h3>Vetinfo</h3>
      </div>
      <div class="flex items-end justify-between gap-2 my-3">
        <div class="flex-1 flex flex-col gap-1">
          <label class="form-label pr-3">Codice fiscale</label>
          <input v-model="fiscal_code" type="text" class="custom-input" />
        </div>
        <div class="flex-1 flex flex-col gap-1">
          <label class="form-label pr-3">Username</label>
          <input v-model="vet_info_user" type="text" class="custom-input" />
        </div>
        <div class="flex-1 flex flex-col gap-1">
          <label class="form-label pr-3">Password</label>
          <input 
              v-model="vet_info_psw"              
              autocomplete="off"
              type="text"
              :style="[!showPword ? '-webkit-text-security: disc' : '']" 
              class="custom-input" 
              />
        </div>
        <button class="w-5 mb-3 flex">
          <div v-if="showPword" @click="showPword = false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              class="h-3 fill-current hover:text-theme-41"
            >
              <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z"
              />
            </svg>
          </div>
          <div v-else @click="showPword = true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
              class="h-3 fill-current hover:text-theme-41"
            >
              <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM223.1 149.5L313.4 220.3C317.6 211.8 320 202.2 320 191.1C320 180.5 316.1 169.7 311.6 160.4C314.4 160.1 317.2 159.1 320 159.1C373 159.1 416 202.1 416 255.1C416 269.7 413.1 282.7 407.1 294.5L446.6 324.7C457.7 304.3 464 280.9 464 255.1C464 176.5 399.5 111.1 320 111.1C282.7 111.1 248.6 126.2 223.1 149.5zM320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L177.4 235.8C176.5 242.4 176 249.1 176 255.1C176 335.5 240.5 400 320 400C338.7 400 356.6 396.4 373 389.9L446.2 447.5C409.9 467.1 367.8 480 320 480H320z"
              />
            </svg>
          </div>
        </button>
      </div>
      <div class="flex justify-end items-center px-6 mt-5">
        <button type="button" class="orange-btn" @click="editVetInfo">
          <EditIcon class="h-5 w-5 mr-2" /> Modifica Vetinfo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

// import { ColorInputWithoutInstance } from 'tinycolor2'
import { ColorPicker } from 'vue3-colorpicker'
import axios from '../../gateway/backend-api'
// import useValidate from '@vuelidate/core'
// import { minLength, sameAs, not } from '@vuelidate/validators'

export default defineComponent({
  components: {
    ColorPicker
  },
  setup() {
    const pureColor = ref()

    const fiscal_code = ref('')
    const vet_info_user = ref('')
    const vet_info_psw = ref('')

    return {
      pureColor,
      fiscal_code,
      vet_info_user,
      vet_info_psw
    }
  },
  data() {
    return {
      isLight: false,
      notValidated: false,
      old_pword: '',
      new_pword: '',
      confirm_pword: '',
      userData: {},
      openPicker: false,
      changePword: false,
      showPword: false
    }
  },
  watch: {
    pureColor: function () {
      this.userData.color = this.pureColor
      this.checkColor()
    }
  },
  created() {
    axios
      .get(
        '/' +
          localStorage.getItem('clinic') +
          '/staff' +
          '/' +
          localStorage.getItem('userId')
      )
      .then((res) => {
        this.userData = res.data
        this.fiscal_code = this.userData.fiscal_code
        if (this.userData.vetinfo) {
          this.vet_info_user = JSON.parse(this.userData.vetinfo).username
          this.vet_info_psw = JSON.parse(this.userData.vetinfo).password
        }
        this.pureColor = this.userData.color
      })
  },

  methods: {
    checkColor() {
      this.isLight = this.isColorLight(this.userData.color)
    },

    isColorLight(hexColor) {
      // Convierte el color hexadecimal a RGB
      const r = parseInt(hexColor.slice(1, 3), 16)
      const g = parseInt(hexColor.slice(3, 5), 16)
      const b = parseInt(hexColor.slice(5, 7), 16)

      // Calcula el brillo relativo del color
      const brightness = (r * 299 + g * 587 + b * 114) / 1000

      // Define un umbral para determinar si es un color claro u oscuro
      const threshold = 128

      return brightness > threshold
    },

    controlPword() {
      // control number of characters
      if (
        this.old_pword.length < 0 ||
        this.new_pword.length < 8 ||
        this.confirm_pword.length < 8
      ) {
        this.notValidated = true
      } else {
        this.notValidated = false
      }

      // control type of characteres
      // eslint-disable-next-line
      let charValidator =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/

      if (
        charValidator.test(this.new_pword) ||
        charValidator.test(this.confirm_pword)
      ) {
        this.notValidated = false
      } else {
        this.notValidated = true
      }
    },

    saveColor() {
      axios
        .post(
          '/' +
            localStorage.getItem('clinic') +
            '/staff' +
            '/' +
            localStorage.getItem('userId') +
            '/change-color',
          { color: this.userData.color }
        )
        .then(() => {
          this.$store.dispatch('commonComponents/openNotificationModal', {
            message: 'Colore salvato con successo!'
          })
          localStorage.setItem('profileColor', this.userData.color)
          this.checkColor()

          console.log(this.userData.color)
          console.log(this.isLight)

          this.$store.dispatch(
            'commonComponents/updateProfileColor',
            this.userData.color
          )
          this.$store.dispatch('commonComponents/updateIsLight', this.isLight)
        })

      this.openPicker = false
    },
    togglePicker() {
      this.openPicker = !this.openPicker
    },
    handleChangePword() {
      this.changePword = !this.changePword
      ;(this.old_pword = ''), (this.new_pword = ''), (this.confirm_pword = '')
    },
    salvaPword() {
      this.controlPword()
      if (this.notValidated) {
        this.$store.dispatch('commonComponents/openNotificationModal', {
          message: 'Controllare le caratteristiche che deve avere la password'
        })
      } else if (this.new_pword !== this.confirm_pword) {
        this.$store.dispatch('commonComponents/openNotificationModal', {
          message: 'La nuova password non coincide con la conferma'
        })
      } else if (this.old_pword === (this.new_pword && this.confirm_pword)) {
        this.$store.dispatch('commonComponents/openNotificationModal', {
          message: 'La nuova password deve essere diversa da quella vecchia'
        })
      } else if (
        this.new_pword === this.confirm_pword &&
        this.old_pword !== (this.new_pword && this.confirm_pword)
      ) {
        axios
          .post('/change-password', {
            token: localStorage.getItem('userToken'),
            staff_user_id: this.userData.id,
            old_password: this.old_pword,
            password: this.new_pword,
            password_confirmation: this.confirm_pword
          })
          .then((res) => {
            if (typeof res.data.status != 'undefined') {
              this.$store.dispatch('commonComponents/openNotificationModal', {
                message: res.data.msg
              })
              if (res.data.status == 'success') this.handleChangePword()
            }
          })
      }
    },
    editVetInfo() {
      axios
        .post('/' + localStorage.getItem('clinic') + '/vetinfo', {
          fiscal_code: this.fiscal_code,
          username: this.vet_info_user,
          password: this.vet_info_psw
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            this.$store.dispatch('commonComponents/openNotificationModal', {
              message: 'Dati Vetinfo modificati con successo'
            })
          }
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.$store.dispatch('commonComponents/openMessageModal', {
              title: 'Errore',
              subtitle: err.response.data.fiscal_code[0]
            })
          }
        })
    }
  }
})
</script>
